// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"f2675255","337":"4466f241"}[chunkId] + ".chunk.css";
};